import axios from "axios";
import config from "../../utils/config";

const HttpService = (token = false, urlApi = "urlApi") => {
  switch (urlApi) {
    case "urlApi":
      urlApi = config.urlApi;
      break;
    case "ipServer":
      urlApi = config.ipServer;
      break;
    default:
      urlApi = config.urlApi;
      break;
  }

  return axios.create({
    baseURL: urlApi,
    // timeout: config.timeout,
    headers: {
      "X-Platform": "APP",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
  });
};

export default HttpService;
